import React from 'react'
import { GridProps } from '../../../../types'
import Grid from '../../../Grid'
import Text from '../../../Text'
import { DropDownOption, DropDownTextStyle, OptionStyleParams } from '../../DropDownTypes'

const DropdownOptionContainer = <T,>({
    option,
    index,
    optionStyle,
    optionTextStyle,
}: {
    option: DropDownOption<T>
    index: number
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    optionStyle?: ((params: OptionStyleParams<any>) => GridProps) | undefined
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    optionTextStyle?: ((params: OptionStyleParams<any>) => DropDownTextStyle) | undefined
}) => {
    const [isHovered, setHovered] = React.useState<boolean>(false)

    return (
        <Grid
            noExpand
            onMouseOver={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            minWidth={0}
            {...(optionStyle &&
                optionStyle({
                    option,
                    index,
                    hover: isHovered,
                }))}
        >
            <Text
                {...(optionTextStyle &&
                    optionTextStyle({
                        option,
                        index,
                        hover: isHovered,
                    }))}
            >
                {option.label}
            </Text>
        </Grid>
    )
}

export default React.memo(DropdownOptionContainer)
